import { z } from 'zod'

import { useTranslation } from '@flecto/translations'
import { type CoreBookingProduct } from '@flecto/types'

type UseFormBookingProductSchemaOptions = {
  bookingProduct?: CoreBookingProduct
}

export function useFormBookingProductSchema(
  options?: UseFormBookingProductSchemaOptions
) {
  const { t } = useTranslation('shared', { keyPrefix: 'validation' })

  const schema = z.object({
    deposit_cents: z.number({ required_error: t('required') }),
    taxable: z.boolean({ required_error: t('required') }),
    tax_rate: z.string({ required_error: t('required') }),
    quantity: z.number({ required_error: t('required') }),
  })

  const initialValues: Partial<CoreBookingProduct> = {
    ...options?.bookingProduct,
  }
  return { schema, initialValues }
}
